import api from "./api";

export const approveTimesheet = async ({ timeSheetId, statusId }) => {
  try {
    const response = await api.put(
      `/Timesheets/${timeSheetId}/approve?statusId=${statusId}`
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const rejectTimesheet = async ({ timeSheetId, statusId, reason }) => {
  try {
    const response = await api.put(
      `/Timesheets/${timeSheetId}/reject?statusId=${statusId}`,
      reason,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const downloadExcel = async (year, month, userTypeId,name,employeeId) => {
  let response
  try {
    //TODO:include &userId=${employeeId}
    response = await api.get(
      `/Timesheets/downloadexcel?year=${year}&month=${month}&userTypeId=${userTypeId}`,
      {
        responseType: "blob",
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }
    );

    // Extract filename from the Content-Disposition header
    const disposition = response?.headers["content-disposition"];
    let filename = `Timesheets_${year}_${name}.xlsx`; // Default filename if not found

    if (disposition && disposition?.includes("filename=")) {
      const match = disposition?.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    // Create a Blob URL for the Excel file
    const blob = new Blob([response?.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    return { url, filename ,response}; // Return both the URL and the filename
  } catch (error) {
    throw response || error;
  }
};
